import { EditableText } from '@smartfire/components';
import { ChildrenBlock, useEditor } from '@smartfire/js-block-engine';
import style from './style.module.scss';
import clsx from 'clsx';

function Template2({ hashtag }) {
    const { isEditing } = useEditor();

    return (
        <div className={clsx(style.template2, isEditing && style.editing)}>
            {(isEditing || hashtag) && (
                <EditableText
                    className={style.hashtag}
                    tagName={'p'}
                    smartProp={'hashtag'}
                    placeholder={'Hashtag...'}
                />
            )}
            <ChildrenBlock
                key="children"
                gutenbergEditorConfig={{
                    orientation: 'vertical',
                    allowedBlocks: ['smartfire/social-networks---media'],
                }}
                className={style.medias}
            />
        </div>
    );
}

export default Template2;
